/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Integration_Flow_Desc4Inputs */

const en_svc_ai_integration_flow_desc4 = /** @type {(inputs: Svc_Ai_Integration_Flow_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop AI into existing user flows, summarization, classification, extraction, drafting, and delegating to a human at the right moments.`)
};

const ar_svc_ai_integration_flow_desc4 = /** @type {(inputs: Svc_Ai_Integration_Flow_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أدخل الذكاء الاصطناعي في تدفقات المستخدم الحالية، تلخيصًا وتصنيفًا واستخراجًا وصياغة، مع تسليم لإنسان في اللحظات المناسبة.`)
};

const bn_svc_ai_integration_flow_desc4 = /** @type {(inputs: Svc_Ai_Integration_Flow_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বিদ্যমান ইউজার ফ্লোতে AI যোগ করুন, সামারাইজেশন, ক্লাসিফিকেশন, এক্সট্রাকশন, ড্রাফটিং, এবং সঠিক মুহূর্তে মানুষের কাছে হ্যান্ড-অফ।`)
};

const de_svc_ai_integration_flow_desc4 = /** @type {(inputs: Svc_Ai_Integration_Flow_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binden Sie KI in bestehende Nutzerabläufe ein: Zusammenfassen, Klassifizieren, Extrahieren, Entwerfen und im richtigen Moment an einen Menschen übergeben.`)
};

const es_svc_ai_integration_flow_desc4 = /** @type {(inputs: Svc_Ai_Integration_Flow_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lleve IA a sus flujos: resúmenes, clasificación, extracción, borradores y derivación a un humano en el momento justo.`)
};

const fr_svc_ai_integration_flow_desc4 = /** @type {(inputs: Svc_Ai_Integration_Flow_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intégrez l'IA à vos flux : résumés, classification, extraction, brouillons et passage de relais à un humain au bon moment.`)
};

const pt_svc_ai_integration_flow_desc4 = /** @type {(inputs: Svc_Ai_Integration_Flow_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leve IA aos fluxos existentes: resumos, classificação, extração, rascunhos e passagem a uma pessoa no momento certo.`)
};

const zh_svc_ai_integration_flow_desc4 = /** @type {(inputs: Svc_Ai_Integration_Flow_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将人工智能放入现有的用户流程中，进行汇总、分类、提取、起草，并在适当的时候委托给人类。`)
};

const tr_svc_ai_integration_flow_desc4 = /** @type {(inputs: Svc_Ai_Integration_Flow_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YZ'yi mevcut kullanıcı akışlarına gömün: özetleme, sınıflandırma, çıkarma, taslak ve doğru anda insana devir.`)
};

const ru_svc_ai_integration_flow_desc4 = /** @type {(inputs: Svc_Ai_Integration_Flow_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Включите ИИ в существующие потоки пользователей, обобщение, классификацию, извлечение, составление проектов и делегирование полномочий человеку в нужные моменты.`)
};

const pl_svc_ai_integration_flow_desc4 = /** @type {(inputs: Svc_Ai_Integration_Flow_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wpleć AI w istniejące flow użytkownika: podsumowania, klasyfikację, ekstrakcję, drafty i przekazanie człowiekowi we właściwym momencie.`)
};

/**
* | output |
* | --- |
* | "Drop AI into existing user flows, summarization, classification, extraction, drafting, and delegating to a human at the right moments." |
*
* @param {Svc_Ai_Integration_Flow_Desc4Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_integration_flow_desc4 = /** @type {((inputs?: Svc_Ai_Integration_Flow_Desc4Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Integration_Flow_Desc4Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_integration_flow_desc4(inputs)
	if (locale === "bn") return bn_svc_ai_integration_flow_desc4(inputs)
	if (locale === "de") return de_svc_ai_integration_flow_desc4(inputs)
	if (locale === "es") return es_svc_ai_integration_flow_desc4(inputs)
	if (locale === "fr") return fr_svc_ai_integration_flow_desc4(inputs)
	if (locale === "pt") return pt_svc_ai_integration_flow_desc4(inputs)
	if (locale === "zh") return zh_svc_ai_integration_flow_desc4(inputs)
	if (locale === "tr") return tr_svc_ai_integration_flow_desc4(inputs)
	if (locale === "ru") return ru_svc_ai_integration_flow_desc4(inputs)
	if (locale === "pl") return pl_svc_ai_integration_flow_desc4(inputs)
	return en_svc_ai_integration_flow_desc4(inputs)
});
export { svc_ai_integration_flow_desc4 as "svc_ai-integration_FLOW_desc" }